import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismCard } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelMarketInsightTablesTableSmartCompsetDetails from 'lumen/components/hotel/market-insight/tables/table-smart-compset-details';

interface HotelMarketInsightCardsSmartCompsetDetailsSignature {
  Args: {
    rateIndexDataForCurrentSelection: unknown;
    setHighlightedMarker: unknown;
  };
}

export default class HotelMarketInsightCardsSmartCompsetDetails extends Component<HotelMarketInsightCardsSmartCompsetDetailsSignature> {
  @service declare miHotels: Services['mi-hotels'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get model() {
    const { rateIndexDataForCurrentSelection } = this.args;

    if (!rateIndexDataForCurrentSelection) {
      return [];
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      rateIndexDataForCurrentSelection
        // @ts-expect-error: Incorrect type
        .map((rateIndex) => {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          const hotel = this.miHotels.gridResponseMapping[rateIndex.ourHotelId];
          const isOwnHotel =
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            rateIndex.ourHotelId === this.miHotels.ownOurHotelId;

          return {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            hotel,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            hotelId: rateIndex.ourHotelId,
            isOwnHotel,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            review: hotel.review_score,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            formattedReview: hotel.formattedReviewScore,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            stars: hotel.stars,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            similarity: hotel.formattedSimilarityScore,
          };
        })
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .filter((hotelData) => hotelData.hotel.compsetClass !== 'own-compset')
    );
  }

  <template>
    <PrismCard
      @contentLayout="noPadding"
      class="detail-pane-card smart-compset-details"
      data-test-id="market-insight-smart-compset-details"
    >
      <:header as |Header|>
        <div class="flex items-center">
          <Header.title>
            {{t
              "market_insight.detail_pane.section_title.smart_compset_overview"
            }}
          </Header.title>
        </div>
      </:header>
      <:content>
        <div class="divider-line divider-line--no-margin-bottom mt-0"></div>
        <HotelMarketInsightTablesTableSmartCompsetDetails
          @model={{this.model}}
          {{! @glint-expect-error: Incorrect type }}
          @setHighlightedMarker={{@setHighlightedMarker}}
        />
      </:content>
    </PrismCard>
  </template>
}
